import api from './api';
import type {
  ShopPromotionListParams,
  ShopPromotionRecord,
} from '../types/shopPromotion';

export interface ShopPromotionListResponse {
  success: boolean;
  data: ShopPromotionRecord[];
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  message?: string;
}

export async function fetchShopPromotions(
  params: ShopPromotionListParams = {}
): Promise<ShopPromotionListResponse> {
  const res = await api.get<ShopPromotionListResponse>('/discount-codes/all', {
    params: {
      shop_only: true,
      page: params.page ?? 1,
      limit: params.limit ?? 20,
      search: params.search,
      restaurant_id: params.restaurant_id,
      discount_type: params.discount_type,
      is_active: params.is_active,
      _t: Date.now(),
    },
  });
  return res.data;
}

export async function fetchShopPromotionById(
  id: number
): Promise<{ success: boolean; data?: ShopPromotionRecord; message?: string }> {
  const res = await api.get<{ success: boolean; data: ShopPromotionRecord }>(
    `/discount-codes/${id}`
  );
  return res.data;
}

export async function createShopPromotion(
  body: Record<string, unknown>
): Promise<{ success: boolean; data?: ShopPromotionRecord; message?: string }> {
  const res = await api.post('/discount-codes/create', body);
  return res.data;
}

export async function updateShopPromotion(
  id: number,
  body: Record<string, unknown>
): Promise<{ success: boolean; data?: ShopPromotionRecord; message?: string }> {
  const res = await api.put(`/discount-codes/${id}`, body);
  return res.data;
}

export async function deleteShopPromotion(
  id: number
): Promise<{ success: boolean; message?: string }> {
  const res = await api.delete(`/discount-codes/${id}`);
  return res.data;
}
